/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Filter_Incomplete_CommentInputs */



/**
* | output |
* | --- |
* | "Incomplete Comment" |
*
* @param {Editor_Filter_Incomplete_CommentInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const editor_filter_incomplete_comment = /** @type {((inputs?: Editor_Filter_Incomplete_CommentInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Filter_Incomplete_CommentInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Commentaire incomplet")
	if (locale === "de") return /** @type {LocalizedString} */ ("Unvollständiger Kommentar")
	if (locale === "it") return /** @type {LocalizedString} */ ("Commento incompleto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Неполный комментарий")
	if (locale === "es") return /** @type {LocalizedString} */ ("Comentario incompleto")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("评论不完整")
	if (locale === "ja") return /** @type {LocalizedString} */ ("不完全なコメント")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अधूरा कमेंट")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Comentário incompleto")
	return /** @type {LocalizedString} */ ("Incomplete Comment")
});